import MirroredGradient, {MirroredGradientPropTypes} from './MirroredGradient';

export type {MirroredGradientPropTypes};
export default MirroredGradient;
